import { withErrReport } from '../../lib/utils';

function ScrollToComponent({ target }) {
  if (process.env.isMiniprogram) {
    target.node.$$getBoundingClientRect().then(rects => {
      wx.pageScrollTo({
        scrollTop: rects.top,
      });
    });
  } else {
    target.node.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'start' });
  }
}

export default withErrReport(ScrollToComponent);
